import React, {useContext, useEffect, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider} from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';


 const IcpdfDirecciones = () => {

    const { DatodetalleDirecciones, datoICPDF } = useContext(UserContext);

    moment.locale('spanish');
    const Fecha = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01

 



useEffect(() => {
    ReporteDirecciones();
   
}, [DatodetalleDirecciones,datoICPDF])


    const TblDireccionesPdf = (
        <>
            {DatodetalleDirecciones.Detalles != null ?
                <View style={{ width: '100%' }}>

                <View style={{ width: '100%' }}>
                <Text style={{ width: '100%', height: '10px', textAlign: 'left' }}>Total direcciones registrada: {DatodetalleDirecciones.Resumen?.NumeroDirecciones}</Text>
                </View>



                    <View style={{ flexDirection: 'row', fontSize: 9, backgroundColor: '#e6e6e6', color: 'black' }}>

                        <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                        <Text style={{ width: '30%', height: '25px', textAlign: 'center' }}>Dirección</Text>
                        <Text style={{ width: '20%', height: '25px', textAlign: 'center' }}>Comuna</Text>
                        <Text style={{ width: '20%', height: '25px', textAlign: 'center' }}>Ciudad</Text>
                        <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Tipo</Text>
                        <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>Fecha Registro</Text>

                    </View>


                    {DatodetalleDirecciones.Detalles.map((resp, id) => (

                        <View style={{ flexDirection: 'row', fontSize: 9 }} key={id}>
                            <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{id + 1}</Text>
                            <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{resp.Direccion}</Text>
                            <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{resp.Comuna}</Text>
                            <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{resp.Ciudad}</Text>
                            <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{resp.Tipo}</Text>
                            <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{resp.Fecha}</Text>

                        </View>
                    ))}

                </View>

                : <Text style={{ fontSize: 9 }} >SIN INFORMACIÓN DE DIRECCIONES</Text>}
        </>
    );


    const ReporteDirecciones = () => (
       
        <Document >
            
            <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
                <View>


                    <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />
                  
                    <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {Fecha}</Text>
                    <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />
                   
                    <View fixed>
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoICPDF.Identificacion?.IsEmpresa ? datoICPDF.DetalleIdentificacionEmpresa?.Nombre : datoICPDF.Identificacion?.Nombre} RUT {datoICPDF.Identificacion?.Rut}</Text>
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DIRECCIONES REGISTRADAS</Text>
                        {TblDireccionesPdf}
                    </View>

                    <View style={{ width: '50%', alignContent: 'left' }}>
                   {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} />*/}
                    <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoICPDF.ID} - {uuid(datoICPDF.ID)}</Text>
                    </View>

                </View>


            </Page>

        </Document>


    );




 

    return useMemo(
        ()=>(
        <div>

        
        <PDFDownloadLink  document={<ReporteDirecciones />} fileName={`${uuid()}.pdf`}>
           
             {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR ARCHIVO PDF</h2>)}
          
        </PDFDownloadLink>
            
           

        </div>
    ),[]
    
);
}

export default IcpdfDirecciones;
